export enum CustomerChatThreadStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum CustomerChatThreadEvent {
  UPDATED = 'CUSTOMER_CHAT_THREAD_UPDATED',
  NEEDS_RESPONSE = 'CUSTOMER_CHAT_THREAD_NEEDS_RESPONSE',
  CLOSED = 'CUSTOMER_CHAT_THREAD_CLOSED',
  REOPENED = 'CUSTOMER_CHAT_THREAD_REOPENED',
}

export enum CustomerChatThreadJob {
  NEEDS_RESPONSE = 'CUSTOMER_CHAT_THREAD_NEEDS_RESPONSE',
}
